module.exports = __webpack_public_path__ + "img/powered-by-swipe-dark.fa0f5593.svg";